<template>
  <sc-modal :active="isActive" @close="closeCallback" :can-cancel="false">
    <sc-modal-card title="Incluir CNPJ">
      <template slot="body">
        <p>Informe o CNPJ do centro de distribuição antes de adicionar o certificado digital.</p>
        <section class="warehouse-info">
          <p><strong>Centro de distribuição</strong></p>
          <p>{{ warehouse_config.warehouse_name }}</p>

          <p><strong>Código: </strong> {{ warehouse_config.warehouse_code }}</p>
          <p><strong>CEP: </strong> {{ warehouse_config.warehouse_zipcode | cep }}</p>
        </section>
        <section class="cnpj-input">
            <sc-field
              prop="federal_tax_payer_id"
              label="CNPJ"
              v-mask="'cnpj'"
              expanded>
              <sc-input v-model="newCnpj" />
            </sc-field>
        </section>
      </template>
      <template slot="footer">
        <sc-button
          theme="default"
          text="Voltar"
          :inverted="true"
          @click="() => closeCallback()"
        />
        <sc-button
          type="submit"
          theme="primary"
          text="Continuar"
          @click="() => continueCallback(newCnpj)"
        />
      </template>
    </sc-modal-card>
  </sc-modal>
</template>
<script>
  import {
    ScModal,
    ScModalCard,
    ScField,
    ScInput,
    ScButton,
  } from '@intelipost-js/secure-components';

  export default {
    name: 'ScAddCnpjModal',
    data() {
      return {
        newCnpj: '',
      };
    },
    props: {
      isActive: {
        type: Boolean,
        required: true,
      },
      warehouse_config: {
        type: Object,
        required: true,
      },
      closeCallback: {
        type: Function,
        required: true,
      },
      continueCallback: {
        type: Function,
        required: true,
      },
    },
    components: {
      ScModal,
      ScModalCard,
      ScField,
      ScInput,
      ScButton,
    },
  };
</script>
<style scoped>
  .warehouse-info, .cnpj-input {
    margin-top: 1em;
  }
</style>


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/configuration-sefaz/components/sc-add-cnpj-modal/ScAddCnpjModal.vue?8a458552